module.exports = "/_next/static/chunks/images/learn-more-background-c4046a1ea59a5c993561a66db1371aff.svg";